var app = angular.module("leonardo");

var ApprovalLog = function($scope, $window, $filter, $stateParams, TaskService) {

  $scope.message = $filter('translate')('Loading file...');

  if ($stateParams.id) {
    TaskService.getApprovalLogPDF($stateParams.id).then(function (url) {
      $window.open(url, '_self');
    }, function (error) {
      $scope.message = $filter('translate')('Sorry, an unexpected error has occurred while trying to get the file.');
    });
  }

};

app.controller('ApprovalLog', ['$scope', '$window', '$filter', '$stateParams', 'TaskService', ApprovalLog]);
